import AgeGender from 'shared/components/content_gating/age_gender';
import AppDownload from 'shared/components/content_gating/app_download';
import Login from 'shared/components/content_gating/login';
import LoginAllaccess from 'shared/components/content_gating/login_allaccess';
import VerifyPhoneNumber from 'shared/components/content_gating/verify_phone_number';
import { IsPremiumUser } from 'shared/vidio_helpers';

export default class ContentGatingBannerFactory {
  static getInstance(currentUser, contentType) {
    const appDownloadBanner = document.querySelector('.content-gating-banner.content-gating-banner--app-download.hide');
    const loginBannerContainer = document.querySelector('.content-gating-banner.content-gating-banner--login.hide');
    const ageGenderBanner = document.querySelector('.content-gating-banner.content-gating-banner--age-gender.hide');
    const loginAllaccessBannerContainer =
      document.querySelector('.content-gating-banner.content-gating-banner--login-allaccess.hide');
    const verifyPhoneNumberBannerContainer =
      document.querySelector('.content-gating-banner.content-gating-banner--verify-phone-number.hide');

    if (appDownloadBanner && !IsPremiumUser.get()) {
      return new AppDownload(appDownloadBanner, currentUser);
    } else if (loginBannerContainer && !currentUser) {
      return new Login(loginBannerContainer);
    } else if (ageGenderBanner && ContentGatingBannerFactory.ageGenderEmpty(currentUser) && !IsPremiumUser.get()) {
      return new AgeGender(ageGenderBanner, currentUser, contentType);
    } else if (loginAllaccessBannerContainer && ( !currentUser || !currentUser.verified_by_allaccess )) {
      return new LoginAllaccess(loginAllaccessBannerContainer, currentUser);
    } else if (verifyPhoneNumberBannerContainer && ( !currentUser || (!currentUser.phone_verified && !IsPremiumUser.get()) )) {
      return new VerifyPhoneNumber(verifyPhoneNumberBannerContainer, currentUser);
    }
  }

  static ageGenderEmpty(currentUser) {
    if(!currentUser) return true;
    return !(currentUser.user_gender_confirmed && currentUser.age);
  }
}